export default "__VITE_ASSET__C9DBC8bl__"